<template>
  <div class="container">
      <section class="section">
      <div class="columns">
          <div class="column">
              <div class="">
                    <p class="is-size-1 has-text-centered has-text-white">Product Code: {{ product.code }}</p>
                    <section class="section has-background-dvolightgrey rounded">
                        <p class="has-text-left is-size-5 has-text-white"> Spare Part Number: {{ product.code}}</p>
                        <p class="has-text-left is-size-5 has-text-white"> Spare part Description: {{ product.description}}</p>
                    </section>
              </div>
          </div>
      </div>
      </section>
    <section class="section">
      <div class="columns">
            <div class="column">
                <p class="is-size-3 has-text-centered has-text-white">Parts</p>
                <b-table
                    :data="product.parts"
                    :bordered="true"
                    :striped="true"
                    :loading="isLoading"
                    :mobile-cards="false"
                    :narrowed="true"
                    :paginated="true"
                    :per-page="10">
                    <b-table-column field="code" label="Part Number" v-slot="props">
                        <router-link
                        :to="{ name: 'Part', params: { id: props.row.number }}"
                        >
                        {{ props.row.number }}
                        </router-link>
                    </b-table-column>                   
                    <b-table-column field="description" label="Part Description" v-slot="props">
                        {{ props.row.description }}
                    </b-table-column>
                    <b-table-column field="code" label="Delete" width="20" numeric v-slot="props">
                    <i @click="deleteProductPart(product.id, props.row.number)" class="far fa-trash-alt has-text-danger"></i> 
                  </b-table-column>                                    
                    <template #empty>
                        <div class="has-text-centered">No records</div>
                    </template>
                </b-table>             
            </div>            
    </div>
    </section>
  </div>
</template>

<script>
import { API } from 'aws-amplify'
import { deleteProductPart} from '../../graphql/mutations'
import { getProductDetail } from '../../graphql/queries';

export default {
    data(){
        return {
            product: null,
            isLoading: false
        }
    },
    methods: {
    async deleteProductPart(a, b){
                this.$buefy.dialog.confirm({
                    title: 'Deleting account',
                    message: 'Are you sure you want to <b>delete</b> this relationship? This action cannot be undone.',
                    confirmText: 'Delete',
                    type: 'is-danger',
                    onConfirm: async () => {
                        try {
                            await API.graphql({
                            query: deleteProductPart,
                                variables: { 
                                    input: 
                                        {
                                            part_number: b,
                                            product_id: a 
                                        }
                                }
                            });

                            this.getProducts()
                            this.$buefy.notification.open({
                                duration: 5000,
                                message: `Deleted`,
                                position: 'is-bottom',
                                type: 'is-success',
                                hasIcon: true
                            })
                        } catch (e) {
                            this.$buefy.notification.open({
                                duration: 5000,
                                message: `${e}`,
                                position: 'is-bottom',
                                type: 'is-danger',
                                hasIcon: true
                            })
                        }

                    }
    })

    },
    async getProducts() {  
        this.isLoading = true;
        try {
        const Products = await API.graphql({
        query: getProductDetail,
            variables: { 
                input: 
                    {
                        id: this.$route.params.id
                    }
            }
        });
        this.product = Products.data.getProductDetail;
        } catch (e) {
            this.$buefy.notification.open({
                duration: 5000,
                message: `${e}`,
                position: 'is-bottom',
                type: 'is-danger',
                hasIcon: true
            })
        }
        this.isLoading = false;

        },
    },
    async created(){
        const Products = await API.graphql({
            query: getProductDetail,
                variables: { 
                    input: 
                    {
                    id: this.$route.params.id
                    }
                }
        });
        this.product = Products.data.getProductDetail
    }
}
</script>

<style scoped>
.modal-card-title{
    color: #d4cece !important;
}
.rounded{
    border-radius: 5px;
}
</style>